import React, { createContext, useContext, useState } from "react";

const LanguageContext = createContext();

export function useLanguage() {
  return useContext(LanguageContext);
}

const translations = {
  fr: {
    // Navbar
    navAbout: "À propos",
    navSkills: "Compétences",
    navExperience: "Expériences",
    navProjects: "Projets",
    navContact: "Contact",

    // Hero
    heroGreeting: "Hello, c'est",
    heroLines: [
      "Passionné de technologie 💻",
      "Développeur Full-Stack 📲💻",
      "Consultant Salesforce ☁",
      "Consultant Mulesoft ☁",
    ],

    // About
    aboutTitle: "À propos",
    aboutP1:
      "Diplômé d'un Master en Informatique en Gestion de données et ingénierie logicielle, je suis actuellement consultant spécialisé en Salesforce et Mulesoft. Fort de mes connaissances en développement web et mobile, ainsi qu'en sécurité informatique, je suis passionné par l'apprentissage continu de nouvelles technologies.",
    aboutP2:
      "Doté d'un excellent sens relationnel et d'une grande capacité à travailler en équipe, je m'efforce de contribuer de manière significative à chaque projet grâce à mes compétences techniques, ma motivation et ma polyvalence.",

    // Skills
    skillsTitle: "Compétences",
    skillsSubtitle:
      "Un écosystème technologique complet - du pixel au déploiement.",
    skillsEyebrow: "CE QUE J'UTILISE",
    catLanguages: "Langages",
    catFrontend: "Frontend",
    catBackend: "Backend",
    catMobile: "Mobile",
    catDatabase: "Bases de données",
    catCloud: "Cloud & CRM",
    catDevops: "DevOps",
    catVersioning: "Versionnement",
    catDesign: "Design",

    // Experience
    expTitle: "Expériences",
    expEyebrow: "MON PARCOURS",
    expSubtitle: "Les étapes clés de mon parcours professionnel.",
    expPresent: "Présent",

    // Projects
    projTitle: "Projets",
    projEyebrow: "MES RÉALISATIONS",
    projSubtitle: "Quelques projets sur lesquels j'ai travaillé.",

    // Contact
    contactTitle: "Contact",
    contactSubtitle: "Discutons de votre prochain projet.",
    contactEyebrow: "ME CONTACTER",
    contactLocation: "Dakar, Sénégal",

    // Footer
    footerRights: "Tous droits réservés",
  },
  en: {
    navAbout: "About",
    navSkills: "Skills",
    navExperience: "Experience",
    navProjects: "Projects",
    navContact: "Contact",

    heroGreeting: "Hello, I'm",
    heroLines: [
      "Tech Enthusiast 💻",
      "Full-Stack Developer 📲💻",
      "Salesforce Consultant ☁",
      "Mulesoft Consultant ☁",
    ],

    aboutTitle: "About me",
    aboutP1:
      "Holding a Master's degree in Computer Science specializing in Data Management and Software Engineering, I currently work as a consultant specialized in Salesforce and Mulesoft. With strong skills in web and mobile development, as well as cybersecurity, I am passionate about continuously learning new technologies.",
    aboutP2:
      "With excellent interpersonal skills and a strong ability to work in teams, I strive to make meaningful contributions to every project through my technical expertise, motivation, and versatility.",

    skillsTitle: "Skills",
    skillsSubtitle:
      "A complete technology ecosystem - from pixel to deployment.",
    skillsEyebrow: "WHAT I WORK WITH",
    catLanguages: "Languages",
    catFrontend: "Frontend",
    catBackend: "Backend",
    catMobile: "Mobile",
    catDatabase: "Databases",
    catCloud: "Cloud & CRM",
    catDevops: "DevOps",
    catVersioning: "Versioning",
    catDesign: "Design",

    expTitle: "Experience",
    expEyebrow: "MY JOURNEY",
    expSubtitle: "Key milestones in my professional career.",
    expPresent: "Present",

    projTitle: "Projects",
    projEyebrow: "MY WORK",
    projSubtitle: "Some projects I have worked on.",

    contactTitle: "Contact",
    contactSubtitle: "Let's discuss your next project.",
    contactEyebrow: "GET IN TOUCH",
    contactLocation: "Dakar, Senegal",

    footerRights: "All rights reserved",
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("fr");
  const t = (key) => translations[lang]?.[key] || key;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}
